import { LoadingLazyComponents } from 'ict24h-themes-react'
import { AppRouterItem } from 'ict24h-themes-react/lib/esm/modules/routers/AppRouters'
import { lazy } from 'react'
import { TASK_TAG_PREFIX_URL } from './constants/config.task-tag'

const ListPage = lazy(() => import('./pages/ListPage.TaskTag'))

const TaskTagRouters: AppRouterItem[] = [
  {
    path: `${TASK_TAG_PREFIX_URL}/`,
    element: (
      <LoadingLazyComponents loadingType="skeleton">
        <ListPage />
      </LoadingLazyComponents>
    ),
  },
]

export default TaskTagRouters
